(function () {

    'use strict';

    angular.module('iplusjs.dateString', [
        'moment',
        'lodash',
        'iplusjs.config',
        'iplusjs.utils.misc'
    ])
        .directive('iplusjsDateString', dateString);

    dateString.$inject = [
        '$timeout',
        'moment',
        'lodash',
        'AppConfig',
        'MiscUtilsService'
    ];
    function dateString($timeout, moment, _, AppConfig, MiscUtilsService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1000,
            scope: {
                modelFormat: '@idsModelFormat',
                viewFormat: '@idsViewFormat',
                formatViewValue: '@idsFormatViewValue',
                yearFormatAllowed: '@idsYearFormatAllowed',
                onBlur: '@idsOnBlur'
            },
            link: linkFnc
        };

        function linkFnc($scope, $element, $attrs, $ngModel) {
            var modelFormat = $scope.modelFormat || AppConfig.API.dateFormat || 'YYYY-MM-DD',
                viewFormat = $scope.viewFormat,
                inputTextSupportedFormat = viewFormat || 'DD.MM.YYYY',
                yearFormatAllowed,
                formatViewValue,
                minVal, maxVal,
                inputType,
                ngModelOptions;

            inputType = $element[0].getAttribute('type') || 'date';
            formatViewValue = MiscUtilsService.isEmpty($scope.formatViewValue) ? true : ($scope.formatViewValue === 'true' ? true : false);
            yearFormatAllowed = $scope.$eval($scope.yearFormatAllowed) || false;

            function parseDateMoment(value, format) {
                return moment(value, format, true);
            }

            function toModelInputText(value) {
                var modelValue = null,
                    formatedValue,
                    modelValueMoment;

                if (MiscUtilsService.isNotEmpty(value)) {
                    modelValueMoment = parseDateMoment(value, ['DD.MM.YYYY', 'DDMMYYYY', 'DD.MMYYYY', 'DDMM.YYYY', 'DDMMYY', 'DD.MM.YY', 'DD.MMYY', 'DDMM.YY']);

                    if (!modelValueMoment.isValid() && yearFormatAllowed && value.length === 4) {
                        modelValueMoment = parseDateMoment(value, 'YYYY');
                    }
                    if (modelValueMoment.isValid()) {
                        modelValue = modelValueMoment.format(modelFormat);
                    }

                    if (MiscUtilsService.isNotEmpty(modelValue)) {
                        if (!formatViewValue) {
                            return modelValue;
                        }

                        formatedValue = moment(modelValue, modelFormat).format(inputTextSupportedFormat);

                        if (value !== formatedValue) {

                            $ngModel.$viewValue = formatedValue;
                            $ngModel.$commitViewValue();
                            $ngModel.$render();
                        }
                    } else {
                        modelValue = value;
                    }
                }

                return modelValue;
            }

            function toModel(value) {
                var momentValue;

                if (_.isNil(value)) {
                    return value;
                }

                momentValue = moment(value, modelFormat);

                return momentValue.isValid() ? momentValue.format(modelFormat) : value;
            }

            function toViewInputText(value) {
                return value ? moment(value, modelFormat).format(inputTextSupportedFormat) : value;
            }

            function toView(value) {
                if (!value) {
                    if ($element && $element[0] && $element[0].disabled) {
                        $timeout(function () {
                            $element[0].value = null;
                        }, 0);
                    }
                    return null;
                }

                if (inputType === 'date') {
                    return moment(value, modelFormat).toDate();
                } else {
                    return toViewInputText(value);
                }
            }

            ngModelOptions = _.cloneDeep($ngModel.$options.$$options);

            if (inputType === 'date' && !$scope.onBlur) {
                $ngModel.$overrideModelOptions(angular.extend({}, ngModelOptions, {
                    updateOn: 'default'
                }));
            } else {
                $ngModel.$overrideModelOptions(angular.extend({}, ngModelOptions, {
                    updateOn: 'blur',
                    debounce: {
                        blur: 0
                    }
                }));
            }
            if (inputType === 'text') {
                $ngModel.$parsers.unshift(toModelInputText);
            }

            $ngModel.$parsers.push(toModel);
            $ngModel.$formatters.push(toView);
            if (inputType === 'text') {
                $ngModel.$validators.date = function (value) {
                    var momentValue = parseDateMoment(value, modelFormat);
                    return momentValue.isValid() || _.isNil(value);
                };

                if (!_.isUndefined($attrs.min) || $attrs.ngMin) {
                    $ngModel.$validators.min = function (value) {
                        var momentValue = parseDateMoment(value, modelFormat);
                        return !momentValue.isValid() || _.isNil(minVal) || momentValue.isSameOrAfter(minVal);
                    };

                    $attrs.$observe('min', function (val) {
                        minVal = parseDateMoment(val, modelFormat);
                        $ngModel.$validate();
                    });
                }

                if (!_.isUndefined($attrs.max) || $attrs.ngMax) {
                    $ngModel.$validators.max = function (value) {
                        var momentValue = parseDateMoment(value, modelFormat);
                        return !momentValue.isValid() || _.isNil(minVal) || momentValue.isSameOrBefore(maxVal);
                    };

                    $attrs.$observe('max', function (val) {
                        maxVal = parseDateMoment(val, modelFormat);
                        $ngModel.$validate();
                    });
                }
            }
        }
    }
})();
